import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useZuschlagsgruppen } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useZuschlagsgruppen/useZuschlagsgruppen';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { DataDisplayPlain } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function Zuschlaege() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;
  const { currentStandort } = useStandortContext();
  const { zuschlagsgruppen } = useZuschlagsgruppen(currentStandort.id);
  return (
    <div className="flex flex-col gap-4">
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlaege.zusammenfassung.label',
        )}
        item={t(
          'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlaege.zusammenfassung.options.' +
            data.bezahlung.zuschlaege.zuschlaege,
        )}
      />
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlagsgruppe.label',
        )}
        item={
          zuschlagsgruppen.find(
            (z) => z.id === data.bezahlung.zuschlaege.zuschlagsgruppe,
          )?.name || '-'
        }
      />
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.pauschaleZuschlaege.label',
        )}
        item={`${data.bezahlung.zuschlaege.pauschaleZuschlaege || '0,00'} €`}
      />
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.uebertariflicheZahlung.label',
        )}
        item={`${data.bezahlung.zuschlaege.uebertariflicheZahlung || '0,00'} €`}
      />
    </div>
  );
}
